var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBellRing(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7134 13.7399H17.4531L16.4023 12.6891C16.1173 12.4041 15.9572 12.0176 15.9572 11.6146V9.2522C15.9572 7.29822 14.7084 5.6359 12.9654 5.01983V4.76447C12.9654 3.9383 12.2957 3.26855 11.4695 3.26855C10.6433 3.26855 9.97358 3.9383 9.97358 4.76447V5.01983C8.23055 5.6359 6.98175 7.29822 6.98175 9.2522V11.6146C6.98175 12.0176 6.82165 12.4041 6.53667 12.6891L5.48584 13.7399H9.22562M13.7134 13.7399V14.4879C13.7134 15.7271 12.7087 16.7318 11.4695 16.7318C10.2302 16.7318 9.22562 15.7271 9.22562 14.4879V13.7399M13.7134 13.7399H9.22562",
    stroke: "#64748B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5875 3.57611C16.9806 3.73125 17.3184 4.00015 17.5577 4.34838C17.797 4.69661 17.927 5.10834 17.931 5.53087M18.3695 0.80339C19.1992 1.05453 19.919 1.58036 20.4104 2.29452C20.9019 3.00868 21.136 3.86874 21.0742 4.73347",
    stroke: "#64748B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.09802 3.57611C5.70498 3.73125 5.36718 4.00014 5.12785 4.34838C4.88852 4.69661 4.75855 5.10834 4.75457 5.53087M4.31607 0.80339C3.48631 1.05453 2.76659 1.58036 2.27511 2.29452C1.78362 3.00868 1.54957 3.86874 1.61139 4.73347",
    stroke: "#64748B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBellRing);
export default __webpack_public_path__ + "static/media/bell-ring.4d9c0cafc3d74f354f2264970a718916.svg";
export { ForwardRef as ReactComponent };